import * as React from 'react';

function EditIcon({ width = 16, height = 16, color = '#545454', ...props }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 24 24'
			fill='none'
			{...props}
		>
			<path
				d='M15 5l4 4m2.174-2.188a2.819 2.819 0 10-3.986-3.987L3.842 16.174a2 2 0 00-.5.83L2.02 21.356a.5.5 0 00.623.622l4.353-1.32a2 2 0 00.83-.497L21.174 6.81z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default EditIcon;
